/**
 * Shared Job types used across multiple features
 * Source: features/jobs - extracted for cross-feature use
 */

export type JobStatusCode =
  | "pending"
  | "starting"
  | "in_progress"
  | "cancelling"
  | "cancelled"
  | "failed"
  | "to_verify"
  | "processed";

export type JobResource =
  | "CREATION BON DE COMMANDE"
  | "UPLOAD FICHIER"
  | "UPLOAD FICHIER SITE"
  | "UPLOAD FICHIER TITRES"
  | "UPLOAD FICHIER CATEGORIES"
  | "CARD REISSUANCE BATCH"
  | "IMPORT EMPLOYEES"
  | "UPLOAD FICHIER AD"
  | "NET BALANCE STATEMENT"
  | "VOUCHER INVOICES EXPORT"
  | "BENEFICIARY EXPORT XLSX"
  | "STOCK LEDGER EXPORT XLSX"
  | "CATALOG BOOKING EXPORT XLSX"
  | "ATTRIBUTION TITRES CADEAUX";

export type JobResult = {
  id: string
  subject: string
  message: string
};

export type Job = {
  comments: string
  created_at: string
  file_name: string
  file_type: string
  is_piece: boolean
  deletable: boolean
  job_piece: {
    url: string
    signed_id: string
  } | null
  organization_id: string
  percent: number
  processed: number
  representative_id: string
  representative_name: string
  resource: JobResource
  result: {
    success?: JobResult[]
    errors?: JobResult[]
    to_verify?: JobResult[]
    error_count?: number
    success_count?: number
    created_count?: number
    updated_count?: number
    to_verify_count?: number
    url?: string | null
    error_url?: string | null
    // Set by the backend cleanup worker once a justificatif ZIP export's file
    // has been purged (>48h). The stored `url` is kept but now 404s, so the UI
    // hides the download and shows an "expired" notice instead.
    file_expired?: boolean
  }
  status_code: JobStatusCode
  status_label: string
  status_color?: string
  import_cancellation_preview?: {
    deletable_count: number
    retained_count: number
  }
  title: string
  total: number
  uuid: string
  id: string
};

export type PushedJob = Pick<
  Job,
  | "uuid"
  | "processed"
  | "total"
  | "percent"
  | "deletable"
  | "resource"
  | "title"
  | "status_code"
  | "status_label"
  | "representative_name"
  | "created_at"
> & { timestamp?: number };

export type JobServiceResponse = { job: Job };

// Status code arrays for filtering
export const IN_PROGRESS_JOB_STATUS: JobStatusCode[] = [
  "pending",
  "starting",
  "in_progress",
  "cancelling",
];
// "cancelled" is a terminal, non-success state (not a failure). It lives here so isComplete()
// recognises it as done; isFailed() is currently unused so this grouping has no UI side effect.
export const FAILED_JOB_STATUS: JobStatusCode[] = ["failed", "cancelled"];
export const SUCCESS_JOB_STATUS: JobStatusCode[] = ["processed", "to_verify"];
